/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.service.userPreferences',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.passes.modals.remove.controllers'
])

.controller('PassesListController', ['$scope', '$state', '$timeout', '$uibModal', '$filter', 'ApiService', 'HelpersService', 'PermissionsService', 'UserPreferencesService', 'NoticeFactory', 'GridStateFactory', 'GridDefinitionFactory', function($scope, $state, $timeout, $uibModal, $filter, ApiService, HelpersService, PermissionsService, UserPreferencesService, NoticeFactory, GridStateFactory, GridDefinitionFactory) {

    $scope.passesList = {

      model: [],
      queryTimer: false,
      searchQuery: '',
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      gridName: $state.current.name+'.grid0',
      notice: new NoticeFactory(),

      dateFormat: UserPreferencesService.getDateFormat('sortDate', 'dateFormat'),

      optionsOverride: {
        enableGridMenu: false,
        data: 'passesList.model',
        sortField: 'name',
        sortDirection: 'asc',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.passesList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.passesList.onDataGridSortChange(grid, columns, page);
          },
          onDblClick: function (item) {
            $scope.passesList.onGridDblClick(item);
          },
          onViewClick: function(item) {
            $scope.passesList.onViewClick(item);
          },
          remove: function (row) {
            $scope.passesList.remove(row);
          }
        },
        columnDefs: [
          {
            field: 'name',
            displayName: 'Name',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'state',
            displayName: 'State'
          },
          {
            field: 'attributes.maxUses',
            displayName: 'Guests Allowed'
          },
          {
            field: 'attributes.maxQuantity',
            displayName: 'Pass Count'
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Pass Ranges',
          buttonRight: {
            label: 'Create Pass Program',
            permissions: 'PASS_RANGES_CREATE',
            action: function() {
              $scope.passesList.cancel();
            }
          }
        });

        this.optionsOverride.columnDefs.push({
          field: 'attributes.startDate',
          displayName: 'Start Date',
          cellFilter: 'date: "'+ $scope.passesList.dateFormat +'"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, $scope.passesList.dateFormat);
          }
        });

        this.optionsOverride.columnDefs.push({
          field: 'attributes.endDate',
          displayName: 'End Date',
          cellFilter: 'date: "'+ $scope.passesList.dateFormat +'"',
          cellFormatter: function(item) {
            return item.value ? $filter('date')(item.value, $scope.passesList.dateFormat) : 'Perpetual';
          }
        });

        if (PermissionsService.check('PASS_RANGES_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.passesList.remove(row);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a class="clickable" title="remove" id="remove" name="remove-configuration-row" data-ng-click="grid.appScope.remove(row)">Remove</a></div>',
            visible: true
          });
        }

        if (PermissionsService.check('PASS_RANGES_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            width: 50,
            onCellNavClick: function(row, col) {
              if (row.entity.state === 'draft') {
                $scope.passesList.onGridDblClick(row);
              }
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a class="clickable" title="edit" id="edit" name="edit-configuration-row" data-ng-hide="row.entity.state === \'published\'" data-ng-click="grid.appScope.onDblClick(row)">Edit</a></div>',
            visible: true
          });
        }

        if (PermissionsService.check('PASS_RANGES_VIEW')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.passesList.onViewClick(row);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a class="clickable" title="view" id="view" name="view-configuration-row" data-ng-click="grid.appScope.onViewClick(row)">View</a></div>',
            visible: true
          });
        }

        this.gridDefinition.init(this.posListGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);
        $scope.$on('DataGrid::UserPreferencesLoaded', this.onUserPreferencesUpdated);

      },

      getPasses: function() {
        ApiService.passes.list(this.gridState.getGridState()).then(this.success.getPasses, this.error.getPasses);
      },

      cancel: function() {
        $state.go('application.passes.create.series');
      },

      remove: function(row) {
        var listItem = row.entity,
          self = $scope.passesList;

        console.log('PosListController::removeProgram');

        self.notice.hideErrorMessages();
        self.notice.hideSuccessMessages();

        self.modalDialog = $uibModal.open({
          templateUrl: 'views/application/views/passes/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'PassesModalsRemoveController',
          resolve: {
            listItem : listItem
          }
        });

        // Invoked when modal completes with close(params)
        self.modalDialog.result.then(function() {
          ApiService.passes.remove(listItem).then(function() {
            self.getPasses();
          }, self.error.remove);
        }, function() {
          // Do nothing
        });
      },

      query: function() {

        if (this.searchQuery) {
          this.gridState.setPropertyValue('search', this.searchQuery);
        }else{
          this.gridState.setPropertyValue('search', '');
        }

        this.getPasses();

      },

      success: {

        init: function(response) {},

        remove: function(response) {},

        getPasses: function(response) {
          var self = $scope.passesList;

          self.model = response.data.payload.list;
          self.gridDefinition.options.totalItems = response.data.payload.pagination.count;
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.gridDefinition.options.gridName,
              datasetLength: self.model.length
            });
          }, 10);

        }

      },

      error: {
        init: function(response) {},
        remove: function(response) {
          var self = $scope.passesList;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);

          $timeout(function() {
            self.notice.hideErrorMessages();
          }, 3000);
        },
        getPasses: function(response) {}
      },

      onViewClick: function(row) {
        if (PermissionsService.check('POS_CONFIG_VIEW')) {
          $state.go('application.passes.detail.series', { id: row.entity.id });
        }
      },

      onGridDblClick: function(row) {
        if (PermissionsService.check('POS_CONFIG_UPDATE')) {
          $state.go('application.passes.edit.series', { id: row.entity.id });
        }
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.passesList;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getPasses();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.passesList,
            data = columns[0];

        if (data) {
          self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          self.getPasses();
        }
      },

      onUserPreferencesUpdated: function() {
        var self = $scope.passesList,
            props = self.gridState.getGridState();

        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getPasses();
      }

    };

    $scope.passesList.init();

}]);